import { useEffect, useRef } from 'preact/hooks';
import { useRouter } from 'preact-router';

interface TourMediaCloseWatcherProps {
  onMediaClose: () => void;
}

/**
 * The single place that detects "the media the user opened just closed", then fires
 * `onMediaClose`. Kept as one dedicated, headless component so this behaviour is easy to find
 * and maintain (rather than sprinkled across ShareModal, habitat pages, or the controller).
 *
 * Detection is route-param based: habitat pages carry `id`, home modal URLs carry `mediaId`;
 * when a previously-present param disappears, the media modal has closed. If you later want to
 * key off a component's own close handler instead, this is the one file to change.
 */
const TourMediaCloseWatcher = ({ onMediaClose }: TourMediaCloseWatcherProps) => {
  const [{ matches }] = useRouter();
  const prevMediaIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const currentMediaId = (matches?.id ?? matches?.mediaId) as string | undefined;
    if (prevMediaIdRef.current && !currentMediaId) onMediaClose();
    prevMediaIdRef.current = currentMediaId;
  }, [matches?.id, matches?.mediaId, onMediaClose]);

  return null;
};

export default TourMediaCloseWatcher;
